import DOCUMENT_CONFIGS from './documentsVerificationConstants';

export default [
    {
        events: [
            DOCUMENT_CONFIGS.ADOPTION
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_ADOPTION,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.ADOPTION_LETTER,
                    DOCUMENT_CONFIGS.LEGAL_GUARDIANSHIP_LETTER,
                    DOCUMENT_CONFIGS.FOREIGN_ADOPTION_LETTER,
                    DOCUMENT_CONFIGS.FOSTER_CARE_LETTER,
                    DOCUMENT_CONFIGS.GOV_ADOPTION_LETTER,
                    DOCUMENT_CONFIGS.COURT_ORDER,
                    DOCUMENT_CONFIGS.MEDICAL_SUPPORT_ORDER
                ]
            }
        ]
    },
    {
        events: [
            DOCUMENT_CONFIGS.BIRTH
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_BIRTH,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.BIRTH_CERT,
                    DOCUMENT_CONFIGS.BIRTH_CONF,
                    DOCUMENT_CONFIGS.MEDICAL_RECORD,
                    DOCUMENT_CONFIGS.HOSPITAL_RECORD,
                    DOCUMENT_CONFIGS.MILITARY_BIRTH_RECORD,
                    DOCUMENT_CONFIGS.FOREIGN_BIRTH_RECORD,
                    DOCUMENT_CONFIGS.RELIGIOUS_BIRTH_RECORD,
                ]
            }
        ]
    },
    {
        events: [
            DOCUMENT_CONFIGS.CHANGE_IN_INCARCERATION,
            DOCUMENT_CONFIGS.INCARCERATION
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_INCARCERATION,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.TIME_SERVED_LETTER,
                    DOCUMENT_CONFIGS.CONV_DISPOSITION_LETTER,
                ]
            }
        ]
    },
    {
        events: [
            DOCUMENT_CONFIGS.CHANGE_IN_LEGAL_PRESENCE
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_LEGAL_PRESENCE,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.I551,
                    DOCUMENT_CONFIGS.T_I551,
                    DOCUMENT_CONFIGS.I766,
                    DOCUMENT_CONFIGS.CUR_VISA_STATUS,
                    DOCUMENT_CONFIGS.COURT_ORDER_IMMIGRATION,
                    DOCUMENT_CONFIGS.NOTICE_OF_HEARING,
                    DOCUMENT_CONFIGS.IMMIGRATION_CONF,
                    DOCUMENT_CONFIGS.USCIS_LETTER,
                    DOCUMENT_CONFIGS.I797_APPROVAL,
                    DOCUMENT_CONFIGS.ICE_LETTER,
                    DOCUMENT_CONFIGS.ICE_STATUS_LETTER,
                    DOCUMENT_CONFIGS.I94,
                    DOCUMENT_CONFIGS.I130,
                    DOCUMENT_CONFIGS.I571,
                    DOCUMENT_CONFIGS.I327,
                    DOCUMENT_CONFIGS.DS2019,
                    DOCUMENT_CONFIGS.ORR_LETTER,
                    DOCUMENT_CONFIGS.WITHHOLDING_LETTER,
                    DOCUMENT_CONFIGS.ASYLUM_LETTER,
                    DOCUMENT_CONFIGS.REMOVAL_CANCELLATION,
                    DOCUMENT_CONFIGS.ADMIN_CLOSURE,
                    DOCUMENT_CONFIGS.ADMIN_STAY_ORDER,
                    DOCUMENT_CONFIGS.ORDER_OF_SUPERVISION,
                    DOCUMENT_CONFIGS.PROOF_OF_STAY
                ]
            }
        ]
    },
    {
        events: [
            DOCUMENT_CONFIGS.CHANGE_IN_TRIBE_STATUS
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_TRIBAL_STATUS,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.TRIBAL_MEMBERSHIP
                ]
            }
        ]
    },
    {
        events: [
            DOCUMENT_CONFIGS.CHANGE_IN_AI_AN_STATUS,
            DOCUMENT_CONFIGS.GAIN_OF_AMERICAN_INDIAN_STATUS,
            DOCUMENT_CONFIGS.GAIN_OF_AI_AN,
            DOCUMENT_CONFIGS.LOSS_OF_AIAN
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_AIAN_STATUS,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.BIA_CERTIFICATION,
                    DOCUMENT_CONFIGS.TRIBAL_MEMBERSHIP
                ]
            }
        ]
    },
    {
        events: [
            DOCUMENT_CONFIGS.CHANGE_IN_CITIZENSHIP
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_CITIZEN_STATUS,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.N550,
                    DOCUMENT_CONFIGS.US_PASSPORT,
                    DOCUMENT_CONFIGS.REAL_ID,
                    DOCUMENT_CONFIGS.US_BIRTH_CERT
                ]
            }
        ]
    },
    {
        events: [
            DOCUMENT_CONFIGS.EXEMPTION_CANCELLED
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_EXEMPTION,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.EXEMPTION_LETTER
                ]
            }
        ]
    },
    {
        events: [
            DOCUMENT_CONFIGS.ICHRA_SEP,
            DOCUMENT_CONFIGS.ICHRA_SEP_FUTURE
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_ICHRA,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.ICHRA_LETTER
                ]
            }
        ]
    },
    {
        events: [
            DOCUMENT_CONFIGS.QSEHRA_SEP,
            DOCUMENT_CONFIGS.QSEHRA_SEP_FUTURE
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_QSEHRA,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.QSEHRA_LETTER
                ]
            }
        ]
    },
    {
        events: [
            DOCUMENT_CONFIGS.INCOME_CHANGE_CSR
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_INCOME_CHANGE,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.PAYCHECK,
                    DOCUMENT_CONFIGS.FORM_1040,
                    DOCUMENT_CONFIGS.WAGES,
                    DOCUMENT_CONFIGS.EARNINGS_STATEMENT,
                    DOCUMENT_CONFIGS.TERM_LETTER,
                    DOCUMENT_CONFIGS.SELF_EMPL_LETTER,
                    DOCUMENT_CONFIGS.FORM_1040_SE,
                    DOCUMENT_CONFIGS.FORM_1065,
                    DOCUMENT_CONFIGS.UNEMPLOYMENT_LETTER,
                    DOCUMENT_CONFIGS.TAX_RETURN,
                    DOCUMENT_CONFIGS.PROFIT_LOSS_STMT,
                ]
            }
        ]
    },
    {
        events: [
            DOCUMENT_CONFIGS.DIVORCE,
            DOCUMENT_CONFIGS.LEGAL_SEPARATION,
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_PRIOR_COVERAGE,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.CARRIER_TERM_LETTER,
                    DOCUMENT_CONFIGS.GOV_TERM_LETTER,
                    DOCUMENT_CONFIGS.COBRA_TERM,
                    DOCUMENT_CONFIGS.COVERAGE_EXHAUSTION_LETTER,
                    DOCUMENT_CONFIGS.PEBPS_LETTER,
                    DOCUMENT_CONFIGS.PREV_EMPL_LETTER,
                    DOCUMENT_CONFIGS.MARKETPLACE_LETTER,
                    DOCUMENT_CONFIGS.STUDENT_HEALTH_COV,
                    DOCUMENT_CONFIGS.DEDUCTION_PAYSTUB
                ]
            },
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_DIVORCE,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.DIVORCE_DECREE
                ]
            }
        ]
    },
    {
        events: [
            DOCUMENT_CONFIGS.LOSS_OF_COVERAGE_THROUGH_EMPLOYER,
            DOCUMENT_CONFIGS.EMPLOYER_SPONSORED_COVERAGE_UNAFFORDABLE,
            DOCUMENT_CONFIGS.EMPLOYER_SPONSORED_COVERAGE_AFFORDABLE,
            DOCUMENT_CONFIGS.LOSS_OF_COVERAGE_THROUGH_EMPLOYER_FUTURE
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_PRIOR_COVERAGE,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.CARRIER_TERM_LETTER,
                    DOCUMENT_CONFIGS.GOV_TERM_LETTER,
                    DOCUMENT_CONFIGS.COBRA_TERM,
                    DOCUMENT_CONFIGS.COVERAGE_EXHAUSTION_LETTER,
                    DOCUMENT_CONFIGS.PEBPS_LETTER,
                    DOCUMENT_CONFIGS.PREV_EMPL_LETTER,
                    DOCUMENT_CONFIGS.MARKETPLACE_LETTER,
                    DOCUMENT_CONFIGS.STUDENT_HEALTH_COV,
                    DOCUMENT_CONFIGS.DEDUCTION_PAYSTUB
                ]
            }
        ]
    },
    {
        events: [
            DOCUMENT_CONFIGS.LOSS_OF_MEDICAID,
            DOCUMENT_CONFIGS.LOSS_OF_MEDICAID_FUTURE
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_LOST_MEDICAID,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.MEDICAID_LETTER
                ]
            }
        ]
    },
    {
        events: [
            DOCUMENT_CONFIGS.LOSS_OF_MEC,
            DOCUMENT_CONFIGS.LOST_OTHER_MIN_ESSENTIAL_COVERAGE,
            DOCUMENT_CONFIGS.LOSS_OF_MEC_FUTURE,
            DOCUMENT_CONFIGS.LOST_OTHER_MIN_ESSENTIAL_COVERAGE_FUTURE
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_PRIOR_COVERAGE,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.CARRIER_TERM_LETTER,
                    DOCUMENT_CONFIGS.GOV_TERM_LETTER,
                    DOCUMENT_CONFIGS.COBRA_TERM,
                    DOCUMENT_CONFIGS.COVERAGE_EXHAUSTION_LETTER,
                    DOCUMENT_CONFIGS.PEBPS_LETTER,
                    DOCUMENT_CONFIGS.PREV_EMPL_LETTER,
                    DOCUMENT_CONFIGS.MARKETPLACE_LETTER,
                    DOCUMENT_CONFIGS.STUDENT_HEALTH_COV,
                    DOCUMENT_CONFIGS.DEDUCTION_PAYSTUB
                ]
            }
        ]
    },
    {
        events: [
            DOCUMENT_CONFIGS.MARRIAGE
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_PRIOR_COVERAGE,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.CARRIER_TERM_LETTER,
                    DOCUMENT_CONFIGS.GOV_TERM_LETTER,
                    DOCUMENT_CONFIGS.COBRA_TERM,
                    DOCUMENT_CONFIGS.COVERAGE_EXHAUSTION_LETTER,
                    DOCUMENT_CONFIGS.PEBPS_LETTER,
                    DOCUMENT_CONFIGS.PREV_EMPL_LETTER,
                    DOCUMENT_CONFIGS.MARKETPLACE_LETTER,
                    DOCUMENT_CONFIGS.STUDENT_HEALTH_COV,
                    DOCUMENT_CONFIGS.DEDUCTION_PAYSTUB
                ]
            },
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_MARRIAGE,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.MARRIAGE_LETTER,
                    DOCUMENT_CONFIGS.DOMESTIC_PARTNER_CERT,
                    DOCUMENT_CONFIGS.MARRIAGE_AFFIDAVIT,
                    DOCUMENT_CONFIGS.RELIGIOUS_MARRIAGE_LETTER,
                ]
            }
        ]
    },
    {
        events: [
            DOCUMENT_CONFIGS.MOVED_INTO_STATE,
            DOCUMENT_CONFIGS.CHANGE_IN_ADDRESS
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_PRIOR_COVERAGE,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.CARRIER_TERM_LETTER,
                    DOCUMENT_CONFIGS.GOV_TERM_LETTER,
                    DOCUMENT_CONFIGS.COBRA_TERM,
                    DOCUMENT_CONFIGS.COVERAGE_EXHAUSTION_LETTER,
                    DOCUMENT_CONFIGS.PEBPS_LETTER,
                    DOCUMENT_CONFIGS.PREV_EMPL_LETTER,
                    DOCUMENT_CONFIGS.MARKETPLACE_LETTER,
                    DOCUMENT_CONFIGS.STUDENT_HEALTH_COV,
                    DOCUMENT_CONFIGS.DEDUCTION_PAYSTUB
                ]
            },
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_CUR_ADDR,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.STATE_ID,
                    DOCUMENT_CONFIGS.DRIVERS_LIC,
                    DOCUMENT_CONFIGS.RENTAL_AGREEMENT,
                    DOCUMENT_CONFIGS.UTIL_BILLS,
                    DOCUMENT_CONFIGS.VOTER_CARD,
                    DOCUMENT_CONFIGS.AUTO_REGISTRATION,
                    DOCUMENT_CONFIGS.HOME_PAYMENT,
                    DOCUMENT_CONFIGS.COLLEGE_ENROLLMENT_LETTER,
                    DOCUMENT_CONFIGS.PROPERTY_TAX,
                    DOCUMENT_CONFIGS.OFFER_OF_EMPLOYMENT,
                    DOCUMENT_CONFIGS.HOME_PURCHASE_AGREEMENT,
                    DOCUMENT_CONFIGS.POSTAL_ADDRESS_LETTER,
                    DOCUMENT_CONFIGS.GOV_LETTERHEAD,
                    DOCUMENT_CONFIGS.BANK_STMT
                ]
            },
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_PREV_ADDR,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.STATE_ID,
                    DOCUMENT_CONFIGS.DRIVERS_LIC,
                    DOCUMENT_CONFIGS.RENTAL_AGREEMENT,
                    DOCUMENT_CONFIGS.UTIL_BILLS,
                    DOCUMENT_CONFIGS.VOTER_CARD,
                    DOCUMENT_CONFIGS.AUTO_REGISTRATION,
                    DOCUMENT_CONFIGS.HOME_PAYMENT,
                    DOCUMENT_CONFIGS.COLLEGE_ENROLLMENT_LETTER,
                    DOCUMENT_CONFIGS.PROPERTY_TAX,
                    DOCUMENT_CONFIGS.OFFER_OF_EMPLOYMENT,
                    DOCUMENT_CONFIGS.HOME_PURCHASE_AGREEMENT,
                    DOCUMENT_CONFIGS.POSTAL_ADDRESS_LETTER,
                    DOCUMENT_CONFIGS.GOV_LETTERHEAD,
                    DOCUMENT_CONFIGS.BANK_STMT
                ]
            }
        ]
    },
    {
        events: [
            DOCUMENT_CONFIGS.CHANGE_IN_HOUSEHOLD_SIZE
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_PRIOR_COVERAGE,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.CARRIER_TERM_LETTER,
                    DOCUMENT_CONFIGS.GOV_TERM_LETTER,
                    DOCUMENT_CONFIGS.COBRA_TERM,
                    DOCUMENT_CONFIGS.COVERAGE_EXHAUSTION_LETTER,
                    DOCUMENT_CONFIGS.PEBPS_LETTER,
                    DOCUMENT_CONFIGS.PREV_EMPL_LETTER,
                    DOCUMENT_CONFIGS.MARKETPLACE_LETTER,
                    DOCUMENT_CONFIGS.STUDENT_HEALTH_COV,
                    DOCUMENT_CONFIGS.DEDUCTION_PAYSTUB
                ]
            }
        ]
    },
];